import React from "react"
import PropTypes from "prop-types"
import FormGroup from "./FormGroup"
import InputMessage from "./styled/InputMessage"
import PasswordInput from "./PasswordInput"

const PasswordFormGroup = ({ id, label, passwordType, error, onChange, className }) => {
  return (
    <FormGroup className={className}>
      <label htmlFor={id} id={`label_${id}`}>
        {label}
      </label>
      <PasswordInput
        id={id}
        autoComplete={`${passwordType}-password`}
        labelId={`label_${id}`}
        onChange={onChange}
      />
      {error && <InputMessage>{error}</InputMessage>}
    </FormGroup>
  )
}

PasswordFormGroup.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  passwordType: PropTypes.oneOf(["current", "new"]).isRequired,
  error: PropTypes.string,
  onChange: PropTypes.func,
}

export default PasswordFormGroup
